<template>
  <div class="footer">
    <div class="footer-content">
      <div class="contact-info">
        <p>联系方式</p>
        <p>电话：13391962508</p>
        <p>微信：longiant</p>
      </div>
      <div class="copyright">
        <p>© 2025 版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
.footer {
  background-color: #fff;
  color: #333;
  padding: 20px 0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  border-top: 1px solid #eee;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.contact-info p {
  margin: 5px 0;
}

.copyright {
  font-size: 0.9em;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
  
  .copyright {
    margin-top: 10px;
  }
}
</style>